module.exports = __webpack_public_path__ + "img/home-slide4-mobile-en-2x.533ac375.png";